<template>

  <div class="exceptions">
    <oButton class="close-exceptions" icon="fas fa-window-close" @click="hdlExceptionClose"/>
    <ul class="exceptions-list" v-if="this.value.exceptions.length != 0">
      <li v-for="exception in value.exceptions" :key="exception.id">
        <p v-for="(object, index) in exception" :key="object.id">
          {{ index | capitalize }} :<span>{{ object | dateFormat(index, object) }}</span>
        </p>
      </li>
    </ul>
    <div v-else class="no-exceptions" >
      <svg class="fas fa-exclamation-triangle"></svg>
      <p>No Exceptions</p>
    </div>
  </div>

</template>

<script>
import oButton from './oButton';

export default {
  name: 'oExceptions',
  props: ['value'],
  components: {
    oButton,
  },
  filters: {
    dateFormat(object, index) {
      if (index == 'timestamp') {
        return new Date(object.toString()).toLocaleString();
      }
      return object;
    },
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods:{
    hdlExceptionClose(e){
      this.$emit('getCloseException', e)
    }
  }
};
</script>

<style>
.close-exceptions .oBtn{
  padding: 2px 4px 0 4px;
  background-color: var(--o-text-on-bg);
  color: var(--o-primary);
  font-size: 30px;
  right: 4px;
  position: absolute;
  top: 4px;
  background: transparent;
}
</style>

<style scoped>
.exceptions {
  width: 100%;
  height: 100%;
  background-color: var(--o-bg1);
  margin: 0 auto;
}
.exceptions-list {
  list-style-type: none;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 0 auto;
  height: 100%;
  overflow-y: auto;
}
.exceptions-list::-webkit-scrollbar {
width: 6px;
height: 6px;
}
.exceptions-list::-webkit-scrollbar-track{
background-color: var(--o-bg1);
}
.exceptions-list::-webkit-scrollbar-thumb{
background-color: var(--o-primary);
}
.close-exceptions{
  position: relative;
}
/* .exceptions-list, .no-exceptions{
  margin-top: -35px;
} */
.no-exceptions {
  display: flex;
  height: 100%;
  min-height: 450px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: var(--o-disable);
}
.no-exceptions p {
  font-size: 18px;
}
.no-exceptions svg {
  font-size: 35px;
}
p {
  display: flex;
  white-space: nowrap;
  padding-left: 10px;
}
li:nth-child(even) {
  background-color: var(--o-bg);
}
span {
  word-wrap: break-word;
  margin-left: 10px;
  white-space: normal;
  min-width: 0;
}
</style>